<script>
import api from '@/helpers/api'
import moment from 'moment'
import { authComputed } from '@/state/helpers'
import { sumBy } from 'lodash'
export default {
  name: 'quantity-stat',
  data () {
    return {
      statData: []
    }
  },
  props: {
    startDate: {
      type: [String, Date],
      default: () => moment().startOf('month').format('YYYY-MM-DD')
    },
    endDate: {
      type: [String, Date],
      default: () => moment().endOf('month').format('YYYY-MM-DD')
    },
    tags: {
      type: Array,
      default: () => []
    }
  },
  mounted () {
    this.onRefresh()
  },
  computed: {
    ...authComputed,
    totalQuantity () {
      return this.statData.quantity
    }
  },
  methods: {
    async onRefresh () {
      const { role, customer_account_id } = this.userProfile
      if (!role) return
      if (role === 'user' && customer_account_id === null) return
      var stats = await api.itemTagStatPerWeek.fetch({
        start_date: this.startDate,
        end_date: this.endDate,
        tags: this.tags,
        customer_id: customer_account_id
      })

      this.statData = stats
    }
  },
  watch: {
    startDate: 'onRefresh',
    endDate: 'onRefresh',
    tags: 'onRefresh',
    userProfile: 'onRefresh'
  }
}
</script>
<template>
  <div>
    {{ totalQuantity }}
  </div>
</template>
